import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class IE8Exception extends Error {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "number", 0);
  }
}